<template>
  <v-row dense class="pa-2">
    <!-- شناسه کانال / کاربری -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.robikaId"
        append-icon="mdi-at"
        label="شناسه روبیکا (Username یا آیدی کانال)"
        placeholder="channel_id"
        prefix="rubika.ir/"
        dir="ltr"
        outlined
        dense
        hint="شناسه را بدون @ یا آدرس کامل وارد کنید"
        persistent-hint
      />
    </v-col>

    <!-- عنوان کسب‌وکار یا کانال -->
    <v-col cols="12" md="6">
      <v-text-field
        v-model="data.organizationName"
        append-icon="mdi-format-title"
        label="عنوان نمایشی کانال / کسب‌وکار"
        placeholder="مثال: کانال رسمی اطلاع‌رسانی روبیکا"
        outlined
        dense
      />
    </v-col>

    <!-- زیرعنوان یا شعار -->
    <v-col cols="12">
      <v-text-field
        v-model="data.subtitle"
        label="زیرعنوان / شعار کوتاه"
        placeholder="مثال: مرجع جدیدترین تخفیف‌ها و ویدیوها"
        outlined
        dense
      />
    </v-col>

    <!-- متن درباره ما -->
    <v-col cols="12">
      <v-textarea
        v-model="data.aboutUs"
        label="متن بیو و توضیحات کامل"
        placeholder="توضیحات و پیام خوش‌آمدگویی به مخاطبان روبیکا..."
        rows="3"
        outlined
        dense
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "robikaBaseInfo",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
